export default {
    Chat: "Chat",
    FileSend: "Send",
    TypeMessage: "Type a message...",


    ERROR_FILE_TOO_MANY: "File limit exceeded!",
}